import { useState, useEffect } from 'react';

function getItem(key: string) {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

export function useSessionStorage(key: string) {
  const [value, setValue] = useState(() => getItem(key));

  useEffect(() => {
    if (value) sessionStorage.setItem(key, value);
    else sessionStorage.removeItem(key);
  }, [value, key]);

  return [value, setValue] as const;
}
